import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
// import Carousel from "react-multi-carousel";
import {
  HomeUpdatedArrowIcon,
  HomeUpdatedNextIcon,
  HomeUpdatedPrevIcon,
  HomeCoreServiceMobile,
  HomeCoreServiceWeb,
  HomeCoreServiceCustom,
  HomeCoreServiceGame,
  HomeCoreServiceDevops,
  HomeCoreServiceITStaff,
  HomeCoreServiceCloud,
} from "../../../app-constants";
import sOne from "../../images/home-update/services/s1.webp";
import sTwo from "../../images/home-update/services/s2.webp";
import sThree from "../../images/home-update/services/s3.webp";
import sFour from "../../images/home-update/services/s4.webp";
import sFive from "../../images/home-update/services/s5.webp";
import sSix from "../../images/home-update/services/s6.webp";
import sSeven from "../../images/home-update/services/s7.webp";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import { Link } from "gatsby";

function Services({ handleShow }) {
  const [swiper, setSwiper] = React.useState();
  const prevRef = React.useRef();
  const nextRef = React.useRef();

  React.useEffect(() => {
    if (swiper) {
      console.log("Swiper instance:", swiper);
      swiper.params.navigation.prevEl = prevRef.current;
      swiper.params.navigation.nextEl = nextRef.current;
      swiper.navigation.init();
      swiper.navigation.update();
    }
  }, [swiper]);

  const allCss = `
    .serv-item .serv-inner::before {
      content: '';
    }
    .home-serv-one .serv-inner::before {
      background-image: url(${sOne});
    }
    .home-serv-two .serv-inner::before {
      background-image: url(${sTwo});
    }
    .home-serv-three .serv-inner::before {
      background-image: url(${sThree});
    }
    .home-serv-four .serv-inner::before {
      background-image: url(${sFour});
    }
    .home-serv-five .serv-inner::before {
      background-image: url(${sFive});
    }
    .home-serv-six .serv-inner::before {
      background-image: url(${sSix});
    }
    .home-serv-seven .serv-inner::before {
      background-image: url(${sSeven});
    }
      `;

  return (
    <>
      <style>{allCss}</style>
      <section className="tekrevol__services overflow-x-hidden p-100">
        <Container>
          <Row>
            <Col
              xs={12}
              md={12}
              lg={12}
              xl={6}
              xxl={6}
              className="mt-auto mb-auto"
            >
              <div className="example example-bottom" data-text="Core Services">
                <h2>Core Services We Provide</h2>
              </div>
            </Col>
            <Col
              xs={12}
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              className="mt-auto mb-auto"
            >
              <div className="serv-tab position-relative">
                <Swiper
                  modules={[Navigation, Pagination]}
                  spaceBetween={25}
                  slidesPerView={3}
                  navigation={{
                    prevEl: prevRef?.current,
                    nextEl: nextRef?.current,
                  }}
                  onSwiper={setSwiper}
                  onSlideChange={() => console.log("slide change")}
                  breakpoints={{
                    320: {
                      slidesPerView: 1,
                    },
                    575: {
                      slidesPerView: 1.5,
                    },
                    666: {
                      slidesPerView: 1.8,
                    },
                    768: {
                      slidesPerView: 2,
                    },
                    1199: {
                      slidesPerView: 2,
                    },
                    1200: {
                      slidesPerView: 3,
                    },
                  }}
                  className="carosal_serv"
                >
                  <SwiperSlide>
                    <div className="serv-item home-serv-one">
                      <div className="serv-inner">
                        <div className="serv-inner-icon">
                          {HomeCoreServiceMobile}
                        </div>
                        <Link
                          to="/mobile-app-development"
                          aria-label="Mobile App Development"
                          className="title_wrap"
                        >
                          <h3 className="title">Mobile App Development</h3>{" "}
                        </Link>
                        <p>
                          We design and develop high-performance mobile
                          applications with seamless user experiences, robust
                          security, and scalable architectures, tailored to meet
                          user and business expansion needs.
                        </p>
                        <Link
                          to="/mobile-app-development"
                          aria-label="Mobile App Development"
                        >
                          {HomeUpdatedArrowIcon}
                        </Link>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="serv-item home-serv-two">
                      <div className="serv-inner">
                        <div className="serv-inner-icon">
                          {HomeCoreServiceWeb}
                        </div>
                        <Link
                          to="/web-development"
                          className="title_wrap"
                          aria-label="Web Development"
                        >
                          <h3 className="title">Web Development</h3>
                        </Link>
                        <p>
                          Our web development services deliver responsive,
                          high-speed websites with secure, scalable back-end
                          solutions, optimized for both user engagement and
                          operational efficiency.
                        </p>
                        <Link
                          to="/web-development"
                          aria-label="Web Development"
                        >
                          {HomeUpdatedArrowIcon}
                        </Link>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="serv-item home-serv-three">
                      <div className="serv-inner">
                        <div className="serv-inner-icon">
                          {HomeCoreServiceCustom}
                        </div>
                        <Link
                          to="/custom-software-development"
                          className="title_wrap"
                          aria-label="Software Development"
                        >
                          <h3 className="title">Software Development</h3>
                        </Link>
                        <p>
                          We create custom software solutions that enhance
                          business processes, featuring advanced integrations,
                          strong security measures, and scalable designs to
                          support your growth.
                        </p>
                        <a href="">{HomeUpdatedArrowIcon}</a>
                        <Link
                          to="/custom-software-development"
                          aria-label="Software Development"
                        >
                          {HomeUpdatedArrowIcon}
                        </Link>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="serv-item home-serv-four">
                      <div className="serv-inner">
                        <div className="serv-inner-icon">
                          {HomeCoreServiceGame}
                        </div>
                        <Link
                          to="/game-development"
                          aria-label="Game Development"
                          className="title_wrap"
                        >
                          <h3 className="title">Game Development</h3>
                        </Link>
                        <p>
                          Our game development expertise spans from concept to
                          deployment. We excel at developing immersive graphics,
                          fluid gameplay, and optimized performance across
                          platforms.
                        </p>
                        <Link
                          to="/game-development"
                          aria-label="Game Development"
                        >
                          {HomeUpdatedArrowIcon}
                        </Link>
                      </div>
                    </div>
                  </SwiperSlide>
                  {/* <SwiperSlide>
                    <div className="serv-item">
                      <div className="serv-inner">
                        <div className="serv-inner-icon">
                          {HomeCoreServiceDevops}
                        </div>
                        <Link
                          to="/devops-enablement"
                          aria-label="DevOps"
                          className="title_wrap"
                        >
                          <h3 className="title">DevOps</h3>
                        </Link>
                        <p>
                          We implement DevOps practices that streamline
                          development and operations. Access impactful automation,
                          continuous integration, and deployment to boost
                          efficiency and reliability.
                        </p>
                        <Link to="/devops-enablement" aria-label="DevOps">
                          {HomeUpdatedArrowIcon}
                        </Link>
                      </div>
                    </div>
                  </SwiperSlide> */}
                  <SwiperSlide>
                    <div className="serv-item home-serv-five">
                      <div className="serv-inner">
                        <div className="serv-inner-icon">
                          {HomeCoreServiceITStaff}
                        </div>
                        <Link
                          to="/solution/it-staff-augmentation"
                          aria-label="IT Staff Augmentation"
                          className="title_wrap"
                        >
                          <h3 className="title">IT Staff Augmentation</h3>
                        </Link>
                        <p>
                          Our IT staff augmentation services provide skilled
                          professionals to augment your team, ensuring you have
                          the right expertise for every project phase.
                        </p>
                        <Link
                          to="/solution/it-staff-augmentation"
                          aria-label="IT Staff Augmentation"
                        >
                          {HomeUpdatedArrowIcon}
                        </Link>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="serv-item home-serv-six">
                      <div className="serv-inner">
                        <div className="serv-inner-icon">
                          {HomeCoreServiceCloud}
                        </div>
                        <Link
                          to="/cloud-computing-consultants"
                          aria-label="Cloud Consulting"
                          className="title_wrap"
                        >
                          <h3 className="title">Cloud Consulting</h3>
                        </Link>
                        <p>
                          We offer cloud consulting services that optimize your
                          cloud strategy, enhance security, and ensure scalable,
                          cost-effective infrastructure designed to complement
                          organizational growth.
                        </p>
                        <Link
                          to="/cloud-computing-consultants"
                          aria-label="Cloud Consulting"
                        >
                          {HomeUpdatedArrowIcon}
                        </Link>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>
                <div ref={prevRef} className="custom-button custom-prev-button">
                  {HomeUpdatedPrevIcon}
                </div>
                <div ref={nextRef} className="custom-button custom-next-button">
                  {HomeUpdatedNextIcon}
                </div>
              </div>
              {/* <Tabs
                              defaultActiveKey="app-dev"
                              id="serv-tab"
                              className="serv-tab all-tabs"
                              justify
                          >
                              <Tab eventKey="app-dev" title="App Development Services">
                              <Swiper
                                  spaceBetween={25}
                                  slidesPerView={3}
                                  onSlideChange={() => console.log('slide change')}
                                  onSwiper={(swiper) => console.log(swiper)}
                                  breakpoints={{
                                      320: {
                                        slidesPerView: 1,
                                      },
                                      575: {
                                          slidesPerView: 1.5,
                                        },
                                      666: {
                                        slidesPerView: 1.8,
                                      },
                                      768: {
                                        slidesPerView: 2,
                                      },
                                      1199: {
                                        slidesPerView: 2,
                                      },
                                      1200: {
                                        slidesPerView: 3,
                                      },
                                    }}
                                  className="carosal_serv"
                                  >
                                      <SwiperSlide>
                                          <div className="serv-item">
                                              <div className="serv-inner">
                                                  <h3 className="title">Mobile App Development</h3>
                                                  <p>We design and develop high-performance mobile applications with seamless user experiences, robust security, and scalable architectures, tailored to meet user and business expansion needs.</p>
                                                  <a href="">{HomeUpdatedArrowIcon}</a>
                                              </div>
                                          </div>
                                      </SwiperSlide>
                                      <SwiperSlide>
                                          <div className="serv-item">
                                              <div className="serv-inner">
                                                  <h3 className="title">Web Development</h3>
                                                  <p>Our web development services deliver responsive, high-speed websites with secure, scalable back-end solutions, optimized for both user engagement and operational efficiency.</p>
                                                  <a href="">{HomeUpdatedArrowIcon}</a>
                                              </div>
                                          </div>
                                      </SwiperSlide>
                                      <SwiperSlide>
                                          <div className="serv-item">
                                              <div className="serv-inner">
                                                  <h3 className="title">Web Development <br className="d-sm-block d-none" />Services</h3>
                                                  <p>Build mobile-friendly websites and web apps to boost your online presence and become more accessible to potential customers through our web development services.</p>
                                                  <a href="">{HomeUpdatedArrowIcon}</a>
                                              </div>
                                          </div>
                                      </SwiperSlide>
                                      <SwiperSlide>
                                          <div className="serv-item">
                                              <div className="serv-inner">
                                                  <h3 className="title">
                                                      Software Development
                                                  </h3>
                                                  <p>We create custom software solutions that enhance business processes, featuring advanced integrations, strong security measures, and scalable designs to support your growth.</p>
                                                  <a href="">{HomeUpdatedArrowIcon}</a>
                                              </div>
                                          </div>
                                      </SwiperSlide>
                                      <SwiperSlide>
                                          <div className="serv-item">
                                              <div className="serv-inner">
                                                  <h3 className="title">
                                                      Game Development
                                                  </h3>
                                                  <p>Our game development expertise spans from concept to deployment. We excel at developing immersive graphics, fluid gameplay, and optimized performance across platforms.</p>
                                                  <a href="">{HomeUpdatedArrowIcon}</a>
                                              </div>
                                          </div>
                                      </SwiperSlide>
                                      <SwiperSlide>
                                          <div className="serv-item">
                                              <div className="serv-inner">
                                                  <h3 className="title">
                                                      DevOps
                                                  </h3>
                                                  <p>We implement DevOps practices that streamline development and operations. Access impactful automation, continuous integration, and deployment to boost efficiency and reliability.</p>
                                                  <a href="">{HomeUpdatedArrowIcon}</a>
                                              </div>
                                          </div>
                                      </SwiperSlide>
                                      <SwiperSlide>
                                          <div className="serv-item">
                                              <div className="serv-inner">
                                                  <h3 className="title">
                                                      IT Staff Augmentation
                                                  </h3>
                                                  <p>Our IT staff augmentation services provide skilled professionals to augment your team, ensuring you have the right expertise for every project phase.</p>
                                                  <a href="">{HomeUpdatedArrowIcon}</a>
                                              </div>
                                          </div>
                                      </SwiperSlide>
                                      <SwiperSlide>
                                          <div className="serv-item">
                                              <div className="serv-inner">
                                                  <h3 className="title">
                                                      Cloud Consulting
                                                  </h3>
                                                  <p>We offer cloud consulting services that optimize your cloud strategy, enhance security, and ensure scalable, cost-effective infrastructure designed to complement organizational growth.</p>
                                                  <a href="">{HomeUpdatedArrowIcon}</a>
                                              </div>
                                          </div>
                                      </SwiperSlide>
                                  </Swiper>
      
                              </Tab>
                              <Tab eventKey="consultation" title="Consultation">
                              <Swiper
                                  spaceBetween={25}
                                  slidesPerView={3}
                                  onSlideChange={() => console.log('slide change')}
                                  onSwiper={(swiper) => console.log(swiper)}
                                  breakpoints={{
                                      320: {
                                        slidesPerView: 1,
                                      },
                                      575: {
                                          slidesPerView: 1.5,
                                        },
                                      666: {
                                        slidesPerView: 1.8,
                                      },
                                      768: {
                                        slidesPerView: 2,
                                      },
                                      1199: {
                                        slidesPerView: 2,
                                      },
                                      1200: {
                                        slidesPerView: 3,
                                      },
                                    }}
                                  className="carosal_serv"
                                  >
                                  <SwiperSlide>
                                      <div className="serv-item">
                                          <div className="serv-inner">
                                              <h3 className="title">
                                                  Mobile App <br className="d-sm-block d-none" />Consulting
                                              </h3>
                                              <p>We help business leaders conceptualize their apps, and identify the correct device compatibility, and development priorities based on their unique challenges.</p>
                                              <a href="">{HomeUpdatedArrowIcon}</a>
                                          </div>
                                      </div>
                                  </SwiperSlide>
                                  <SwiperSlide>
                                      <div className="serv-item">
                                          <div className="serv-inner">
                                              <h3 className="title">
                                                  Scope of <br className="d-sm-block d-none" />Work Creation
                                              </h3>
                                              <p>Our business analyst team identifies a wide selection of features for your app, works with you to align the correct development priorities, and finalizes the cost of development for your project</p>
                                              <a href="">{HomeUpdatedArrowIcon}</a>
                                          </div>
                                      </div>
                                  </SwiperSlide>
                                  <SwiperSlide>
                                      <div className="serv-item">
                                          <div className="serv-inner">
                                              <h3 className="title">
                                                  Game Design Document Creation
                                              </h3>
                                              <p>Our game designers draw a high-level document, sketching the concept, flow, storyline, characters, mechanics, gameplay, and technical specifications that will guide your game’s development.</p>
                                              <a href="">{HomeUpdatedArrowIcon}</a>
                                          </div>
                                      </div>
                                  </SwiperSlide>
      
                                  </Swiper>
      
                              </Tab>
                              <Tab eventKey="dev-support" title="Development Support Services">
                                  <Swiper
                                      spaceBetween={25}
                                      slidesPerView={3}
                                      onSlideChange={() => console.log('slide change')}
                                      onSwiper={(swiper) => console.log(swiper)}
                                      breakpoints={{
                                          320: {
                                            slidesPerView: 1,
                                          },
                                          575: {
                                              slidesPerView: 1.5,
                                            },
                                          666: {
                                            slidesPerView: 1.8,
                                          },
                                          768: {
                                            slidesPerView: 2,
                                          },
                                          1199: {
                                            slidesPerView: 2,
                                          },
                                          1200: {
                                            slidesPerView: 3,
                                          },
                                        }}
                                      className="carosal_serv"
                                      >
                                      <SwiperSlide>
                                          <div className="serv-item">
                                              <div className="serv-inner">
                                                  <h3 className="title">
                                                      Mobile App <br className="d-sm-block d-none" />Testing and QA
                                                  </h3>
                                                  <p>We work with pre-existing apps to weed out the bugs and code errors that result in crashes and solve them to ensure a seamless experience for your users, resulting in increased retention rates.</p>
                                                  <a href="">{HomeUpdatedArrowIcon}</a>
                                              </div>
                                          </div>
                                      </SwiperSlide>
                                      <SwiperSlide>
                                          <div className="serv-item">
                                              <div className="serv-inner">
                                                  <h3 className="title">
                                                      Mobile App <br className="d-sm-block d-none" />Integration
                                                  </h3>
                                                  <p>Connect your mobile applications with a wide range of APIs or integrate third-party software to seamlessly improve your customer experience and functionality.</p>
                                                  <a href="">{HomeUpdatedArrowIcon}</a>
                                              </div>
                                          </div>
                                      </SwiperSlide>
                                      <SwiperSlide>
                                          <div className="serv-item">
                                              <div className="serv-inner">
                                                  <h3 className="title">
                                                      Mobile App <br className="d-sm-block d-none" />Maintenance
                                                  </h3>
                                                  <p>Access high-end app maintenance services from L1 to L3, security and data compliance, load management and optimization to bug fixes and performance management.</p>
                                                  <a href="">{HomeUpdatedArrowIcon}</a>
                                              </div>
                                          </div>
                                      </SwiperSlide>
                                      <SwiperSlide>
                                          <div className="serv-item">
                                              <div className="serv-inner">
                                                  <h3 className="title">
                                                      Mobile App <br className="d-sm-block d-none" />Modernization
                                                  </h3>
                                                  <p>Modernize the infrastructure of your legacy applications, refactor code, and improve the user experience to give your mobile app a modern look and feel.</p>
                                                  <a href="">{HomeUpdatedArrowIcon}</a>
                                              </div>
                                          </div>
                                      </SwiperSlide>
      
                                      </Swiper>
                              </Tab>
                              <Tab eventKey="startup-dev" title="Development Support Services">
                              <Swiper
                                      spaceBetween={25}
                                      slidesPerView={3}
                                      onSlideChange={() => console.log('slide change')}
                                      onSwiper={(swiper) => console.log(swiper)}
                                      breakpoints={{
                                          320: {
                                            slidesPerView: 1,
                                          },
                                          575: {
                                              slidesPerView: 1.5,
                                            },
                                          666: {
                                            slidesPerView: 1.8,
                                          },
                                          768: {
                                            slidesPerView: 2,
                                          },
                                          1199: {
                                            slidesPerView: 2,
                                          },
                                          1200: {
                                            slidesPerView: 3,
                                          },
                                        }}
                                      className="carosal_serv"
                                      >
                                      <SwiperSlide>
                                          <div className="serv-item">
                                              <div className="serv-inner">
                                                  <h3 className="title">
                                                      MVP <br className="d-sm-block d-none" />Development
                                                  </h3>
                                                  <p>A service built for startups, we help plan, build, and deploy minimum viable products(MVP) in 2 months for a quick product launch.</p>
                                                  <a href="">{HomeUpdatedArrowIcon}</a>
                                              </div>
                                          </div>
                                      </SwiperSlide>
                                      <SwiperSlide>
                                          <div className="serv-item">
                                              <div className="serv-inner">
                                                  <h3 className="title">
                                                      Prototype <br className="d-sm-block d-none" />Development
                                                  </h3>
                                                  <p>Build your interactive proof of concept for investors or tradeshows and gain rapid market feedback on your product to refine your product vision.</p>
                                                  <a href="">{HomeUpdatedArrowIcon}</a>
                                              </div>
                                          </div>
                                      </SwiperSlide>
      
                                      </Swiper>
                              </Tab>
                          </Tabs> */}
            </Col>
            <Col
              xs={12}
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              className="mt-auto mb-auto"
            >
              <div className="btn-wrap text-center">
                <span className="btn-pri" onClick={handleShow}>
                  Consult Transformation Goals
                </span>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default Services;
